import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../app-config';

// models
import { SchoolData } from 'src/app/models/schoolUser';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  public schoolProps!: SchoolData;

  constructor(private httpClient: HttpClient, private apiUrl: AppConfig) { }

  public getUserData = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.meCall + '?from=' + filterData);
  };

  public schoolChoices = (choices: any): Observable<any> => {
    return this.httpClient.get<any>(
      this.apiUrl.schoolApiUrl.myChoices + choices
    );
  };

  public registerChoices = (choices: any): Observable<any> => {
    return this.httpClient.get<any>(
      this.apiUrl.schoolApiUrl.registerChoices + choices
    );
  };

  public publicSchool = (schoolName: any): Observable<any> => {
    return this.httpClient.get<any>(
      this.apiUrl.schoolApiUrl.publicProfile + schoolName
    );
  };
  public resetLinkAuth = (emailLink: any): Observable<any> => {
    return this.httpClient.get<any>(
      this.apiUrl.commonApi.resetLinkAuth + emailLink
    );
  };
  public resetPassword = (resetData: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.commonApi.resetPassword,
      resetData
    );
  };

  public checkboxPatches(value: any) {
    return value == true ? '1' : '0';
  }

  public getLocalStorageData(key: string) {
    this.schoolProps = JSON.parse(localStorage.getItem(key) || '{}');
    return this.schoolProps;
  }

  public recentJobs = (): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.schoolApiUrl.recentJobs);
  };

  public schoolStaff = (): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.schoolApiUrl.schoolStaff);
  };

  public updateSchoolStaff = (
    staffData: any,
    staffId: number
  ): Observable<any> => {
    return this.httpClient.put<any>(
      this.apiUrl.schoolApiUrl.updateSchoolStaff + staffId + '/',
      staffData
    );
  };

  public deleteSchoolStaff = (staffIds: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.schoolApiUrl.deleteSchoolStaff,
      staffIds
    );
  };

  public createSchoolStaff = (staffData: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.schoolApiUrl.updateSchoolStaff,
      staffData
    );
  };

  public makeRtaAdmin = (staffData: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.schoolApiUrl.manageTeamSettings,
      staffData
    );
  };

  public switchBackToPython = (): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.commonApi.switchBackToPython, {
      tryAngular: false,
    });
  };
  public switchBackToPythonTeacher = (): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.commonApi.switchBackToPythonTeacher, {
      tryAngular: false,
    });
  };



  public nudgeInactiveTeachersAPI = (): Observable<any> => {
    return this.httpClient.get<any>(
      this.apiUrl.schoolApiUrl.nudgeInactiveTeachersAPI
    );
  };
  public loginToAngular = (rtaUser: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.commonApi.loginToAngular,
      rtaUser
    );
  };

  checkEmailExists(email: string): Observable<any> {
    return this.httpClient.get<any>(
      `${this.apiUrl.commonApi.checkEmailExists}?email=${encodeURIComponent(email)}`
    );
  }
  signUpAPI(data: any): Observable<any> {
    return this.httpClient.post<any>(this.apiUrl.commonApi.signUp, data);
  }
  public getCannyIntegration = (): Observable<any> => {
    return this.httpClient.get<any>(
      this.apiUrl.schoolApiUrl.getCannyIntegration
    );
  };
  public logout = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.commonApi.logout,
      data
    );
  };
  public mfaVerifyAPI = (resetData: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.commonApi.mfaVerifyAPI,
      resetData
    );
  };
  public mfaOTPVerifyAPI = (resetData: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.commonApi.mfaOTPVerifyAPI,
      resetData
    );
  };
  public enableMfaOtpVerifyAPI = (resetData: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.commonApi.enableMfaOtpVerifyAPI,
      resetData
    );
  };
  public enableMFA(): Observable<any> {
    return this.httpClient.post<any>(
      this.apiUrl.commonApi.enableMFA,
      {}
    );
  }
  public disableMFA(): Observable<any> {
    return this.httpClient.post<any>(
      this.apiUrl.commonApi.disableMFA,
      {}
    );
  }
  public resendMFAOtp(payload: any): Observable<any> {
    return this.httpClient.post(
      this.apiUrl.commonApi.resendMFAOtp,
      payload
    );
  }
  public resendVerifyOtp(payload: any): Observable<any> {
    return this.httpClient.post(
      this.apiUrl.commonApi.resendVerifyOtp,
      payload
    );
  }

  public sendSmsMFAOtp(payload: any): Observable<any> {
    return this.httpClient.post(
      this.apiUrl.commonApi.sendSmsMFAOtp,
      payload
    );
  }

  public inviteByEmail(data: any): Observable<any> {
    return this.httpClient.get<any>(
      this.apiUrl.schoolApiUrl.inviteByEmail + '?staff=' + encodeURIComponent(data)
    );
  }

  public inviteByEmailTRACER(data: any): Observable<any> {
    return this.httpClient.get<any>(
      this.apiUrl.tracerApi.tracerAddAdditionalUserApi + 'search/?staff=' + encodeURIComponent(data)
    );
  }

  public addQLDRolesAndPermissions(payload: any): Observable<any> {
    return this.httpClient.post(
      this.apiUrl.schoolApiUrl.addQLDRolesAndPermissions,
      payload
    );
  }

  public addQLDRolesAndPermissionsTracer(payload: any): Observable<any> {
    return this.httpClient.post(
      this.apiUrl.tracerApi.tracerAddAdditionalUserApi,
      payload
    );
  }

  public getUserDataForSwitchUser = (id: any): Observable<any> => {
    const headers = id
      ? { headers: { 'switch-user': id } }
      : {};
    return this.httpClient.get<any>(this.apiUrl.meCall + '?from=' + id, headers);
  };


  public getMySchoolAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.commonApi.mySchoolApi, { params: filterData });
  };

  public isLongDayBookingEnabled = (isLongDayBooking: any): Observable<any> => {
    return this.httpClient.post(
      this.apiUrl.commonApi.isLongDayBookingEnabled,
      isLongDayBooking
    );
  }

}
